import BorderStyle from './_border-style.js'
import FlexContainerBase from './_flex-container-base.js'
import ConfigurableFlex from './_configurable-flex.js'
import ConfigurableBackground from './_configurable-background.js'
import SelectableButton from './_selectable-button.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import ButtonScrollPane from './_button-scroll-pane.js'

export default {
  name: 'MenuRow',
  values: {
    overlayInteractionOnItemClick: true,
    style: {
      container: {
        borderStyle: {
          configSet: BorderStyle,
          configValues: {},
        },
        boxShadow: undefined,
        margin: 0,
        padding: '0',
        width: '100%',
        height: '40px',
        justifyContent: 'center',
        boxSizing: 'border-box',
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: ConfigurableFlex,
          },
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
    },
    item: {
      configSet: SelectableButton,
      configValues: {
        unselected: {
          style: {
            base: {
              flexGrow: 1,
              flexShrink: 0,
              flexBasis: 'auto',
              alignItems: 'center',
              minHeight: '100%',
              minWidth: '70px',
              padding: '0 4px',
              flexDirection: 'row',
            },
          },
        },
        selected: {
          style: {
            base: {
              flexGrow: 1,
              flexShrink: 0,
              flexBasis: 'auto',
              alignItems: 'center',
              minHeight: '100%',
              minWidth: '70px',
              padding: '0 4px',
              flexDirection: 'row',
            },
          },
        },
        indicator: {
          style: {
            base: {
              width: '80%',
              height: '2px',
              top: 'auto',
              bottom: '0',
              transitionProperty: 'background-color, height',
              transitionDuration: '0.15s',
              margin: '0 auto',
              left: 0,
              right: 0,
            },
            unselected: {
              width: '80%',
              height: '0px',
            },
          },
        },
      },
    },
    itemInnerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    itemLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          whiteSpace: 'nowrap',
        },
        container: {
          flexGrow: 0,
          flexShrink: 1,
          flexBasis: 'auto',
        },
      },
    },
    selectedItemLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          whiteSpace: 'nowrap',
        },
        container: {
          flexGrow: 0,
          flexShrink: 1,
          flexBasis: 'auto',
        },
      },
    },
    showItemIcon: true,
    itemIcon: {
      configSet: Image,
      configValues: {
        style: {
          height: '16px',
          minWidth: '16px',
          maxWidth: '100%',
        },
      },
    },
    selectedItemIcon: {
      configSet: Image,
      configValues: {
        style: {
          height: '16px',
          minWidth: '16px',
          maxWidth: '100%',
        },
      },
    },
    chevronIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '10px',
          minHeight: '10px',
          padding: '2px 0 0 0',
        },
      },
    },
    buttonScrollPane: {
      configSet: ButtonScrollPane,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
